import { render, staticRenderFns } from "./MarketingSiteTemplates.vue?vue&type=template&id=7c0dc48e&scoped=true"
import script from "./MarketingSiteTemplates.vue?vue&type=script&lang=js"
export * from "./MarketingSiteTemplates.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteTemplates.vue?vue&type=style&index=0&id=7c0dc48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0dc48e",
  null
  
)

export default component.exports